import { Briefcase, TrendingUp, Target, Trophy, Activity, CheckCircle2 } from "lucide-react";
import AnimatedNumber from "../AnimatedNumber";

const StatRow = ({ icon: Icon, label, children, sub }) => (
  <div className="flex items-center gap-3">
    <div className="w-9 h-9 rounded-lg bg-white/10 text-[#EDEDED] flex items-center justify-center flex-shrink-0">
      <Icon size={16} />
    </div>
    <div className="min-w-0 flex-1">
      <div className="text-[#A1A1AA] text-xs leading-tight">{label}</div>
      <div className="font-mono text-lg leading-tight">{children}</div>
      {sub && <div className="text-[#71717A] text-[10px] mt-0.5">{sub}</div>}
    </div>
  </div>
);

const StatsPanel = ({ stats }) => {
  const closedIncome = stats.closed_income ?? 0;
  const realizedRoi = stats.realized_roi ?? stats.roi ?? 0;
  const activeInvestment = stats.active_investment ?? 0;
  const winRate = stats.win_rate ?? 0;
  const bestRoi = stats.best_roi ?? 0;
  const activeCount = stats.active_count ?? 0;
  const closedCount = stats.closed_count ?? 0;

  // Rule: green only for earned income & PnL (Реализованный доход, ROI).
  const incomeCls = closedIncome >= 0 ? "text-[#34D399] pnl-glow-up" : "text-[#F87171] pnl-glow-down";
  const roiCls = realizedRoi >= 0 ? "text-[#34D399] pnl-glow-up" : "text-[#F87171] pnl-glow-down";

  return (
    <div className="bg-[#0A0A0A] rounded-xl border border-[#1F1F1F] p-6" data-testid="stats-panel">
      <h3 className="font-bold text-white mb-5">Эффективность</h3>
      <div className="space-y-4">
        <StatRow
          icon={Briefcase}
          label="Капитал в работе"
          sub={`${activeCount} ${activeCount === 1 ? "активная сделка" : "активных сделок"}`}
        >
          <AnimatedNumber value={activeInvestment} suffix=" $" className="text-white" />
        </StatRow>
        <StatRow
          icon={TrendingUp}
          label="Реализованный доход"
          sub={`По ${closedCount} ${closedCount === 1 ? "закрытой сделке" : "закрытым сделкам"}`}
        >
          <AnimatedNumber value={closedIncome} suffix=" $" showSign flash className={incomeCls} />
        </StatRow>
        <StatRow icon={Target} label="ROI (по закрытым)">
          <AnimatedNumber value={realizedRoi} suffix=" %" showSign flash className={roiCls} />
        </StatRow>
        <StatRow icon={CheckCircle2} label="Win Rate" sub="% прибыльных закрытых">
          <AnimatedNumber value={winRate} decimals={1} suffix=" %" className="text-white" />
        </StatRow>
        <StatRow icon={Trophy} label="Лучшая сделка">
          <AnimatedNumber value={bestRoi} suffix=" %" showSign className="text-white" />
        </StatRow>
        <StatRow icon={Activity} label="Всего сделок" sub={`${activeCount} актив. / ${closedCount} закр.`}>
          <span className="text-white">{activeCount + closedCount}</span>
        </StatRow>
      </div>
    </div>
  );
};

export default StatsPanel;
